import React from 'react';
import { useStaticQuery } from 'gatsby';
import LinksListElement from './LinksListElement';
import * as styles from './LinksList.module.scss';
var LinksList = function LinksList() { var _useStaticQuery = useStaticQuery("945847551"), allNavigationLinksJson = _useStaticQuery.allNavigationLinksJson; var links = allNavigationLinksJson.nodes; return /*#__PURE__*/ React.createElement("ul", { className: styles.linksList }, links.map(function (link) { return /*#__PURE__*/ React.createElement(LinksListElement, { key: link.label, link: link }); })); };
export default LinksList;
